import React from "react";

import { formatDuration } from "../services/date";
import { Row } from "./Row";

export function TimeButton({
  decrementDisabled = false,
  incrementDisabled = false,
  onDecrement,
  onIncrement,
  value,
}) {
  return (
    <Row>
      <button
        type="button"
        className="o-btn o-btn--small o-btn--basic"
        onClick={() => onDecrement(value)}
        disabled={decrementDisabled}
      >
        -
      </button>
      <div className="u-mh-small" style={{ minWidth: 32 }}>
        {formatDuration(value)}
      </div>
      <button
        type="button"
        className="o-btn o-btn--small o-btn--basic"
        onClick={() => onIncrement(value)}
        disabled={incrementDisabled}
      >
        +
      </button>
    </Row>
  );
}
